<template>
    <div class="c-modal-wrapper c-has-dark-blue-header">
      <!-- Application Header -->
      <header class="c-modal-header">
        <div class="c-responsive-container">
          <div class="c-as-block c-has-header-buttons">
            <div class="c-grid-row">
              <div class="c-col-6 c-align-right">
                <button class="c-btn" v-on:click="cancelChanges()"><i aria-hidden="true" class="fa fa-times c-ux-color-danger"></i> <b>Otkaži</b></button>                
              </div>
              <div class="c-col-6 c-align-left">
                <button class="c-btn" v-on:click="saveChanges()"><i aria-hidden="true" class="fa fa-check c-ux-color-success"></i> <b>Sačuvaj</b></button>                
              </div>
            </div>
          </div>
        </div>
      </header>
      <!-- Body content -->
      <div class="c-modal-body c-has-skewed-background c-to-full-bottom">
        <div class="c-responsive-container">
          <form class="c-p-10" v-on:submit.prevent>
            <div class="c-info-title-labels-wrap">
              <button class="c-info-icon"><i class="fa fa-info-circle" aria-hidden="true"></i></button>
              <div class="c-info-title"><b>Detalji korisnika (admina)</b></div>
            </div>
            <!-- Name, Last name -->
            <div class="c-grid-row">
              <div class="c-col-6">
                <div class="c-form-group c-blue-style">
                  <label for="admin-first-name">Ime administratora</label>
                  <input type="text" class="c-form-control" id="admin-first-name" name="admin-first-name"
                    v-model="formVars.firstName.model">
                </div>
              </div>
              <div class="c-col-6">
                <div class="c-form-group c-blue-style">
                  <label for="admin-last-name">Prezime administratora</label>
                  <input type="text" class="c-form-control" id="admin-last-name" name="admin-last-name"
                    v-model="formVars.lastName.model">
                </div>
              </div>
            </div>
            <!-- Nickname, Phone -->
            <div class="c-grid-row">
              <div class="c-col-6">
                <div class="c-form-group c-blue-style">
                  <label for="admin-nickname">Nadimak</label>
                  <input type="text" class="c-form-control" id="admin-nickname" name="admin-nickname"
                    v-model="formVars.nickName.model">
                </div>
              </div>
              <div class="c-col-6">
                <div class="c-form-group c-blue-style">
                  <label for="admin-phone-number">Telefon</label>
                  <input type="text" class="c-form-control" id="admin-phone-number" name="admin-phone-number"
                    v-model="formVars.phone.model">
                </div>
              </div>
            </div>
            <!-- Account Email -->
            <div class="c-grid-row">
              <div class="c-form-group c-blue-style">
                <label for="admin-email">Pristupni email</label>
                <input type="text" class="c-form-control" id="admin-email" name="admin-email"
                v-model="formVars.email.model" disabled>
              </div>
            </div>
            <!-- Admin role -->
            <div class="c-grid-row">
              <div class="c-form-group c-blue-style">
                <label for="admin-role">Uloga korisnika (stepen pristupa aplikaciji)</label>
                <select class="c-form-control" id="admin-role" name="admin-role" v-model="formVars.accessRoleKey.model">
                  <option value="null">Izaberite...</option>
                  <option 
                    v-for="(singleAccessRole, key) in listOfAccessLevels" 
                    v-bind:value="singleAccessRole.accessLevel"
                    v-if="singleAccessRole.title"
                  >{{singleAccessRole.title}} ({{singleAccessRole.accessGroup}} Level - {{singleAccessRole.accessLevel}})</option>
                </select>
              </div>
            </div>
          </form>
        </div>        
      </div>
      <!-- Application Footer Menu -->
      <!-- <footer class="c-modal-footer">
        <div class="c-responsive-container c-relative c-p-0-10">
          <div class="c-grid-row c-footer-action-buttons-wrap">
            <div class="c-col-6 c-align-right">
              <button class="c-btn c-btn-default c-btn-edit-mode-round-buttons c-ux-color-success" v-on:click="saveChanges()"><i class="fa fa-check" aria-hidden="true"></i> <b>Sačuvaj</b></button>
            </div>
            <div class="c-col-6 c-align-left">
              <button class="c-btn c-btn-default c-btn-edit-mode-round-buttons c-ux-color-danger" v-on:click="cancelChanges()"><i class="fa fa-times" aria-hidden="true"></i> <b>Otkaži</b></button>
            </div>
          </div>
        </div>
      </footer> -->
    </div>
</template>

<script>
import router from '@/router/index'
import EventBus from '@/EventBus'
import {firebaseDB} from '@/firebase';
export default {
  name: 'ModalAdminDetails',
  props: ['inputModalData'],
  data () {
    return {
      isLoading: [1],
      msg: 'ModalAdminDetails modal',
      //
      formVars: {
        isValid: false,
        adminUid: null,
        firstName: {
          model: null,
          inFocus: false,
          showError: false,
          //accept any character (min 2 lenght)
          //pattern: /^.{2,}$/,
          errorMsg: 'Error'
        },
        lastName: {
          model: null,
          inFocus: false,
          showError: false,
          //accept any character (min 2 lenght)
          //pattern: /^.{2,}$/,
          errorMsg: 'Error'
        },
        nickName: {
          model: null,
          inFocus: false,
          showError: false,
          //accept any character (min 2 lenght)
          //pattern: /^.{2,}$/,
          errorMsg: 'Error'
        },
        phone: {
          model: null,
          inFocus: false,
          showError: false,
          //accept any character (min 2 lenght)
          //pattern: /^.{2,}$/,
          errorMsg: 'Error'
        },
        email: {
          model: null
        },
        accessRoleKey: {
          model: null,
          inFocus: false,
          showError: false,
          //accept any character (min 2 lenght)
          //pattern: /^.{2,}$/,
          errorMsg: 'Error'
        }        
      },
      resolve: null,
      reject: null
    }
  },
  firebase: function () {
    return {
      listOfAccessLevels: {
        source: firebaseDB.ref('listOfAppAccessLevels'),
        //asObject: true,
        // optionally provide the cancelCallback, if the app client doesn't have permission to read from that database reference
        //cancelCallback: function (error) {console.log('!!! - IMPORTANT - cancelCallback');},
        // this is called once the data has been retrieved from firebase
        readyCallback: function (dataSnapshot) {
          this.isLoading.pop();
          //once we have list of all access levels, we can update 'selected option' to be one that user has
          //this.setSelectedAccessLevelFromUser(dataSnapshot);
        }
      }      
    }
  },
  watch: {
    'formVars.accessRoleKey.model' : function (newValue){
      console.log('formVars.accessRoleKey.model changed to: ' + newValue);
    }
  },
  methods: {
    deepCopy: function (inputData){
      var clonedData = JSON.parse(JSON.stringify(inputData))
      return clonedData;
    },
    // ~ update form fields values after component is binded to view
    updateFieldValues: function () {
      //console.log('this.inputModalData.dataForModal.key: ' + this.inputModalData.dataForModal['.key']);
      this.formVars.adminUid = (this.inputModalData.dataForModal['.key']) ? this.inputModalData.dataForModal['.key'] : null;
      this.formVars.firstName.model = (this.inputModalData.dataForModal.firstName) ? this.inputModalData.dataForModal.firstName : null;
      this.formVars.lastName.model = (this.inputModalData.dataForModal.lastName) ? this.inputModalData.dataForModal.lastName : null;
      this.formVars.nickName.model = (this.inputModalData.dataForModal.nickName) ? this.inputModalData.dataForModal.nickName : null;
      this.formVars.phone.model = (this.inputModalData.dataForModal.phone) ? this.inputModalData.dataForModal.phone : null;
      this.formVars.email.model = (this.inputModalData.dataForModal.email) ? this.inputModalData.dataForModal.email : null;
      this.formVars.accessRoleKey.model = (this.inputModalData.dataForModal.accessRoleKey) ? this.inputModalData.dataForModal.accessRoleKey : null;

      // this.formVars.adminUid = this.inputModalData.dataForModal['.key'];
      // this.formVars.firstName.model = this.inputModalData.dataForModal.firstName;
      // this.formVars.lastName.model = this.inputModalData.dataForModal.lastName;
      // this.formVars.nickName.model = this.inputModalData.dataForModal.nickName;
      // this.formVars.phone.model = this.inputModalData.dataForModal.phone;
      // this.formVars.email.model = this.inputModalData.dataForModal.email;
      // this.formVars.accessRoleKey.model = this.inputModalData.dataForModal.accessRoleKey;
    },
    // ~ calculate what is selected access level that user has
    // setSelectedAccessLevelFromUser: function (inputAllAccessLevels) {
    //   console.log('inputAllAccessLevels: ' + JSON.stringify(inputAllAccessLevels, null, 2) );
    //   var tmpObject = this.deepCopy(inputAllAccessLevels);
    //   var tmpCurrentAccessLevelKey = this.inputModalData.dataForModal.accessRoleKey;
    //   // if (tmpObject && tmpCurrentAccessLevelKey){
    //   //   for (var property in tmpObject) {
    //   //     if (tmpObject.hasOwnProperty(property) && property === tmpCurrentAccessLevelKey){
    //   //       console.log('accessRoleKey.model: ' + this.formVars.accessRoleKey.model);
    //   //       console.log('property: ' + property + ', tmpObject[property]: ' + tmpObject[property] );
    //   //       console.log('access level: ' + tmpObject[property].accessRoleKey);
    //   //       //this.formVars.accessRoleKey.model = tmpObject[property].accessRoleKey;
    //   //       this.formVars.accessRoleKey.model = property;
    //   //     };
    //   //   }
    //   // }
    // },
    // ~ When we want to save changes created on this modal
    saveChanges: function (){
      this.isLoading.push(1);
      firebaseDB.ref().child('/listOfUsers/' + this.formVars.adminUid).update({
          //email: this.newlyCreatedUserData.email,
          firstName:  (this.formVars.firstName.model) ? this.formVars.firstName.model : null,
          lastName:  (this.formVars.lastName.model) ? this.formVars.lastName.model : null,
          nickName:  (this.formVars.nickName.model) ? this.formVars.nickName.model : null,
          //nickName: (this.formVars.nickName.model) ? this.formVars.nickName.model : "--",
          phone:  (this.formVars.phone.model) ? this.formVars.phone.model : null,
          accessRoleKey:  (this.formVars.accessRoleKey.model) ? this.formVars.accessRoleKey.model : null
        }).then(
          function (response) {
            //console.log('Firebase Account Details succ: ' + JSON.stringify(response, null, 2));
            var resultToReturn = {
              tempMsg: 'ModalAdminDetails returns Yes'
            }
            this.resolve(resultToReturn);
          }.bind(this),
          function (error){
            console.log('Firebase Account Details ERROR: ' + JSON.stringify(error, null, 2));
          }.bind(this)
        );
    },
    // ~ When we want to discard changes
    cancelChanges: function (){
      this.reject();
    }
  },
  created () {
    //console.log('~ created- ModalAdminDetails component!');
    //    
    if (this.inputModalData){
      //console.log('inputModalData: ' + JSON.stringify(this.inputModalData, null, 2) );
      this.resolve = this.inputModalData.resolve;
      this.reject = this.inputModalData.reject;
      this.updateFieldValues();
    }
  },
  mounted () {
    //console.log('~ mounted - ModalAdminDetails component!');
    // ~ after our component is binded to view, we will update values of each field
    //this.updateFieldValues();    
  },
  destroyed () {
    //console.log('~ destroyed- ModalAdminDetails component!');
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style></style>



// WEBPACK FOOTER //
// src/components/adminsList/ModalAdminDetails.vue